import * as R from 'ramda'

export function priceAmount(price: unknown): number {
  return Number(R.pathOr(0, ['unit_amount'], price)) / 100
}

export function priceInterval(price: unknown): string | undefined {
  return R.path(['recurring', 'interval'], price)
}

export function monthlyAmount(type: string, amount: number | string): number {
  return type === 'month' ? Number((+amount).toFixed(2)) : Number((+amount / 12).toFixed(2))
}



// WEBPACK FOOTER //
// ./src/libs/billing/price/index.ts